import PropTypes from 'prop-types';
import React from 'react';
import ToolTip from '../../../../Elements/ToolTip/ToolTip';

import './TdContent.scss';

export default class TdContent extends React.PureComponent {
    static propTypes = {
        /**
         * data to be render
         */
        data: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        /**
         * toolTip message
         */
        tooltipMsg: PropTypes.string,
    };

    static defaultProps = {
        data: null,
        tooltipMsg: null,
    };

    renderData = () => {
        if (this.props.tooltipMsg) {
            return (
                <span
                    style={{ cursor: 'pointer' }}
                    onMouseEnter={(e) => {
                        this.tooltip.show(e);
                    }}
                    onTouchStart={(e) => {
                        this.tooltip.show(e);
                    }}
                    onMouseLeave={(e) => {
                        this.tooltip.hide(e);
                    }}
                >
                    {this.props.data}
                </span>
            );
        } else {
            return <span>{this.props.data}</span>;
        }
    };

    render() {
        return (
            <div className="component-Employer-Benefits-IndustryTable-TdContent">
                {this.renderData()}

                <ToolTip
                    ref={(node) => {
                        this.tooltip = node;
                    }}
                    type=""
                    direction="up"
                >
                    {this.props.tooltipMsg}
                </ToolTip>
            </div>
        );
    }
}
